'use strict';

export const searchResultsElements = () => ({
    providerLocationTemplate: document.querySelector('template#provider-location'),
    noResultsTemplate: document.querySelector('template#no-results'),
    scrollContainer: document.querySelector('div#search-results div.scroll-container'),
    scrollContainerSmall: document.querySelector('div#scroll-container-small'),
    resultsContainer: document.querySelector('div#search-results div.scroll-container div.container'),
    tag: text => {
        const tag = document.createElement('button');
        tag.classList.add('tag');
        tag.setAttribute('data-tag-value', text);
        const tagIcon = document.createElement('img');
        tagIcon.src = '/icons/tag.svg';
        tagIcon.alt = 'tag icon';

        // @todo: This can be done better
        let shortenedTags = text.split(' ');
        if (shortenedTags.length > 2) {
            if (shortenedTags.indexOf('&') > -1 && shortenedTags.length >= 3) {
                shortenedTags = shortenedTags.slice(0, 3).join(' ');
            } else {
                shortenedTags = shortenedTags.slice(0, 2).join(' ') + '...';
            }
        } else {
            shortenedTags = shortenedTags.join(' ');
        }
        tag.innerHTML = shortenedTags;
        tag.append(tagIcon);
        return tag.outerHTML;
    },
    tags: () => (document.querySelectorAll('button.tag')),
    titles: () => (document.querySelectorAll('div.result-title span')),
    image: img => {
        const image = document.createElement('img');
        image.src = img;
        return image.outerHTML;
    },
    phone: number => {
        const li = document.createElement('li');
        const icon = document.createElement('img');
        icon.src = '/icons/phone.svg';
        icon.alt = 'phone icon';
        const a = document.createElement('a');
        a.href = `tel:${number}`;
        a.innerHTML = number;
        li.append(icon);
        li.append(a);
        return li.outerHTML;
    },
    website: url => {
        const li = document.createElement('li');
        const icon = document.createElement('img');
        icon.src = '/icons/home.svg';
        icon.alt = 'home icon';

        url = url.toLowerCase();
        url = url.replace('http://', '');
        url = url.replace('https://', '');
        url = url.replace('/', '');

        const a = document.createElement('a');
        a.href = `https://${url}`;
        a.target = '_blank';
        a.innerHTML = url;
        li.append(icon);
        li.append(a);
        return li.outerHTML;
    },
    email: email => {
        const li = document.createElement('li');
        const icon = document.createElement('img');
        icon.src = '/icons/mail.svg';
        icon.alt = 'email icon';
        const a = document.createElement('a');
        a.href = `mailto:${email}`;
        a.innerHTML = email;
        li.append(icon);
        li.append(a);
        return li.outerHTML;
    },
    paymentMethods: (paymentmethods) => {
        const li = document.createElement('li');
        const icon = document.createElement('img');
        icon.src = '/icons/coins.svg';
        icon.alt = 'payment method icon';
        const span = document.createElement('span');
        span.innerHTML = paymentmethods;
        li.append(icon);
        li.append(span);
        return li.outerHTML;
    },
    searchResultsTitle: document.querySelector('.search-results-title'),
    searchResultsCount: document.querySelector('.search-results-count'),
    searchResult: number => {
        return document.querySelector(`#result-${number}`);
    },
    providerLocation: (
        template,
        data,
        categoriesAndTags,
        paymentMethods,
        number,
        image = '',
        phone = '',
        website = '',
        email = '',
        col = 'col-8',
        location
    ) => {
        const truncate = text => {
            if (text.length > 200) {
                const compare = text;
                let truncated = text.substr(0, 200);
                truncated = truncated.substr(
                    0,
                    Math.min(truncated.length, truncated.lastIndexOf(" ")
                    )
                );
                if (truncated !== compare) {
                    truncated += '...';
                    return truncated;
                }
            }
            return text;
        };

        const distance = data => {
            const to = (data.city === '' || typeof data.city === 'undefined') ? 'Afstand: ' : data.city + ': ';
            return (typeof data.distance !== 'undefined' && !isNaN(data.distance)) ?
                (to + parseFloat(data.distance).toFixed(1) + 'km') :
                '';
        };

        return template
            .replace('${image}', image)
            .replace('${title}', data.title)
            .replace('${number}', number)
            .replace('${categoriesAndTags}',
                categoriesAndTags.slice(0, 10).map(catOrTag => {
                    return catOrTag;
                }).join('')
            )
            .replace('${paymentMethods}', paymentMethods)
            .replace('${adText}', truncate(data.adText))
            .replaceAll('${link}', '/' + data.url)
            .replace('${id}', number)
            .replace('${distance}', distance(data))
            .replace('${phone}', phone)
            .replace('${website}', website)
            .replace('${email}', email)
            .replace('${col}', col)
            .replace('${location}',location);
    }
});
